import $http from './../../axios-instance';
import Swal from 'sweetalert2';
import {getAcls} from '../../plugins/acl';
import store from "@/store/store";

export async function authentication({ commit, state },router) {
    commit("dashboard/load", true, { root: true });
  // Agregar el token del recaptcha
  const payload = {
    ...state.ingreso
  }
  try {
    const response = await $http.post('/auth/login', payload);
    localStorage.setItem('token', 'Bearer ' + response.data.data.token)
    localStorage.setItem('acl', JSON.stringify(response.data.data.acl))
    localStorage.setItem('email', payload.email)
    localStorage.setItem('cambio_clave', JSON.stringify(response.data.data.cambio_clave))
    localStorage.setItem('my_company', response.data.data.company_id);
    commit('setMyCompany', response.data.data.company_id);
    if(response.data.data.version)localStorage.setItem('version',response.data.data.version.version);
    commit('setRol');
    commit('setEmailUserLogged',payload.email);
    commit("resetAttempts", 0);
    commit("changeCloseSession", false);
    commit("clearOriginalRequest");
    commit("dashboard/load", false, { root: true });
    if(response.data.data.licence_warging)commit("setLicenseWarning", response.data.data.licence_warging);
    router.push('/inicio');
  } catch (error) {
    commit('reloadRECAPTCHA');
    commit("dashboard/load", false, { root: true });
    this.$vue.$alertError(error.message,5000,false, '¡Error de autenticación!');
  }
}

/***
 * Mostrar alerta que indique cuando vence la licencia
 *
 * @param {Object} commit
 * @param {Object} state
 */
export function showLicenceAlert({ commit, state }) {
  if(state.licence_warning) {
      const licenceWarning = state.licence_warning;
      this.$vue.$alertConfirmation({
          icon: "warning",
          title: "Su licencia esta por vencer",
          text: licenceWarning,
          showConfirmButton: true,
          titleBtnConfirm: "Ok, salir.",
          onConfirm: () => commit("setLicenseWarning", null)
      });
  }
}

/**
 * Autorización con Microsoft Azure.
 *
 * @param {Object} commit
 * @param {Object} code: codigo, router: instancia de router.
 * @returns {Promise<Callback>}
 * @author Fernando Claros
 */
export async function authenticationAzure({ commit, }, {code, router}) {
    commit("dashboard/load", true, { root: true });

    try {

        const response = await $http.post(`${process.env.VUE_APP_API}/auth/microsoft.online/callback`, {
            _cco: code,
            _cni: localStorage.getItem("login.microsoft.online-CCN"),
            _cid: localStorage.getItem("login.microsoft.online-CID")
        });

        localStorage.setItem("token", "Bearer " + response.data.data.token);
        localStorage.setItem("acl", JSON.stringify(response.data.data.acl));
        localStorage.setItem("cambio_clave", JSON.stringify(response.data.data.cambio_clave));
        localStorage.setItem('my_company', response.data.data.company_id);
        commit('setMyCompany', response.data.data.company_id);

        if (response.data.data.version)
            localStorage.setItem("version", response.data.data.version.version);

        commit("setRol");
        commit("dashboard/load", false, { root: true });

        callbackAuthAzure(commit, false, router);

    } catch (error) {
        commit("dashboard/load", false, { root: true });
        commit('setMicrosoftOnlineMessageError', error.message);
        callbackAuthAzure(commit, true);
    }
}

function callbackAuthAzure(commit, hasError, router) {
    commit('setMicrosoftOnlineLoadingAccessMicrosoftToApp', false);
    setTimeout(() => {

        setTimeout(async () => {
            commit('setMicrosoftOnlineLoadingAccessToSoluquim', false);
            commit('setMicrosoftOnlineHasErrorInSessionUser', hasError);

           if(!hasError) await router.push({path: "/inicio"});
        }, 200);
    }, 200);
}

export async function recuperacionContraseña({state}) {
  return new Promise(async (resolve, reject) => {
    await $http.post('auth/reset-password', state.olvido)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message + '<br> ' + error.errors,
          showConfirmButton: true,
          timer: 5000
        });
        reject(error);
      });
  });
}


export async function vigenciaToken({ state }) {
    return new Promise(async(resolve, reject) => {
        await $http.post('auth/validate-token', state.cambio)
            .then((response) => {

            })
            .catch((error) => {
                reject(error);
            })
    })
}


export async function cambioContraseña({ state }) {
    return new Promise(async(resolve, reject) => {
        await $http.post('cambiaPassword', state.cambio)
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    text: error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
    })
}

export async function cambioContraseñaOlvidada({ state }) {
    return new Promise(async(resolve, reject) => {
        await $http.post('auth/change-forgotten-password', state.cambio)
            .then((response) => {
                resolve(response);

            }).catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    text: error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
    })
}

export async function logout({commit}) {
  if (localStorage.getItem('token')) {

    const acls = getAcls();

    const parametros = {
      uuid: acls.uuid
    };

    commit('dashboard/load', true, {root: true});

    await $http.post('/auth/logout', parametros)
      .then(() => {
        commit('dashboard/load', false, {root: true});
        localStorage.clear();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        console.log(error.response.data);
      });
  }
}

/**
 * Cargar todos los tanques según parámetros del cliente para una empresa en especifico.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} params: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function validateIsCurrentUserAHuman({ commit }, params) {
  commit('resetReCAPTCHA');
  commit('setLoading', true);

  await $http.post(`auth/verify-current-user/is-human`, params)
    .then(({ data: response }) => {
      commit('setReCAPTCHA', { isValid: true, response: response });
    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Autenticación de usuarios',
        text: 'Ups, no fue posible realizar las validaciones de seguridad (Google reCAPTCHA).',
        showConfirmButton: true,
      })
    })
    .finally(() => commit('setLoading', false));
}


/**
 * Verificar si la empresa existe.
 *
 * Con el nit proporcionado en la URL se verifica si el nit
 * ingresado es valido en las bases de datos de SOLUQUIM.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} nit
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function verifiedNitCompanyAndPermissionsToUseLogin({ commit }, nit) {
    commit('resetMicrosoftOnline');
    localStorage.setItem("login.microsoft.online-CCN", null);
    localStorage.setItem("login.microsoft.online-CID", null);

    await $http.get(`auth/microsoft.online/verified-nit-company/${nit}`)
      .then(({data: response}) => {
        localStorage.setItem("login.microsoft.online-CCN", nit);
        localStorage.setItem("login.microsoft.online-CID", response.data._cid);
        changeStatusMicrosoftOnline(response.data, commit)
      })
      .catch(errors => {
        if(errors && typeof errors === 'object' && 'errors' in errors)
            changeStatusMicrosoftOnline(null, commit, errors.errors.valid_nit, errors.errors.use_azure, false);
      });
  }


function changeStatusMicrosoftOnline(response = null, commit, isValidNitCompany = true, isValidPermissions = true, next = true) {
    commit('setMicrosoftOnlineNitCompany', {
        loading: false,
        isValid: isValidNitCompany
    });

    setTimeout(() => {
        commit('setMicrosoftOnlinePermissions', {
            loading: false,
            isValid: isValidPermissions
        });

        commit('setMicrosoftOnlineIsValidConfigsAzure', {
            loading: false,
            isValid: isValidPermissions
        });

        setTimeout(() => {
            commit('setMicrosoftOnlineAccessToMicrosoft', {
                loading: next,
                isValid: next
            });

            if (next) window.location.href = `${process.env.VUE_APP_API_AUTH_MICROSOFT}?_cid=${response._cid}&_cni=${response._cni}`
        }, 500);
    }, 500);
}

/*
 * Guardar información del tiempo de actividad del usuario
 *
 * @param commit
 * @param params -> payload
 * @returns {Promise<void>}
 */
export async function saveTimeActiveFromUserAuth(state, payload) {
    try {
         await $http.post(`users/save-time-active`, payload);
    } catch (error) {
        return Promise.reject(error.message)
    }
}




/*
 * Guardar información del tiempo de actividad del usuario
 *
 * @param commit
 * @param params -> { data: formData, actions: {closeModal: this.closeModal, updateList: this.listarFabricantes} }
 * @returns {Promise<void>}
 */
export async function getTotalUsersTime({ commit }, payload) {

    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`users/get-total-users-time`, {params: payload});
        commit('setUserTime',response.data.data)
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: error.message,
            html: htmlErrors,
            showConfirmButton: true,
        })
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

/*
 * Obtener información basica del usuario
 *
 * @param commit
 * @param params -> { data: formData, actions: {closeModal: this.closeModal, updateList: this.listarFabricantes} }
 * @returns {Promise<void>}
 */
export async function getBasicInfo({ commit }, userId) {

    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`users/basic-info/${userId}`);
        commit('setBasicicInfoUser',response.data.data)
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}
